/**
     * @desc 下架NFT
通过合约下架NFT前，pending当前listing
id：；listing的id
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/cancelListing', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/cancelListing', params);
}
